module.exports = __webpack_public_path__ + "img/shopping-cart.png?v=5d344222";